interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  inline?: boolean;
}

export default function Loading({ size = 'sm', inline = false }: Props) {
  const sizeMap = { xs: '8', sm: '8', md: '10', lg: '12' };
  const wh = sizeMap[size];
  return (
    <div className={inline ? '' : 'flex items-center justify-center h-screen'}>
      <div className={`w-${wh} h-${wh} loader`}>
        <div className="loader-text">Loading...</div>
      </div>
    </div>
  );
}
